import { render, staticRenderFns } from "./BottomTab.vue?vue&type=template&id=43b66c87&scoped=true"
import script from "./BottomTab.vue?vue&type=script&lang=js"
export * from "./BottomTab.vue?vue&type=script&lang=js"
import style0 from "./BottomTab.vue?vue&type=style&index=0&id=43b66c87&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b66c87",
  null
  
)

export default component.exports